import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'dmp-operator-label-and-or',
    templateUrl: './operator-label-and-or.component.html',
    imports: [
        NgClass,
        NgIf,
        DropdownModule,
        FormsModule,
        TranslateModule
    ],
    styleUrls: ['./operator-label-and-or.component.scss']
})
export class OperatorLabelAndOrComponent implements OnInit {
    @Input() public readOnly = false;
    @Input() public typeGroup = 'AND';
    @Output() public typeGroupChange: EventEmitter<string> = new EventEmitter();

    public options: { label: string; value: string }[] = [];

    public editMode = false;

  constructor(private trans: TranslateService) {
      this.options = [
          { label: this.trans.instant('common.operator.OR'), value: 'OR' },
          { label: this.trans.instant('common.operator.AND'), value: 'AND' }
      ];
  }

  ngOnInit(): void {
  }

  public onEditMode(): void {
      if (!this.readOnly) {
        this.editMode = true;
      }
  }

    setValue(typeGroup: 'AND' | 'OR') {
        this.typeGroup = typeGroup;
        this.typeGroupChange.emit(this.typeGroup);
        this.editMode = false;
    }
}
